import { useEffect, useRef, useState } from "react";
import type { ChronologyEvent } from "~/api/model";
import type { ChronologyDuplicateGroup } from "../helpers/detectDuplicateEvents";

export const useDetectDuplicateGroups = (
  events: ChronologyEvent[]
): ChronologyDuplicateGroup[] => {
  const [groups, setGroups] = useState<ChronologyDuplicateGroup[]>([]);
  const workerRef = useRef<Worker | null>(null);

  useEffect(() => {
    const worker = new Worker(
      new URL("../helpers/detectDuplicatesWorker.ts", import.meta.url),
      { type: "module" }
    );
    worker.onmessage = (e: MessageEvent<ChronologyDuplicateGroup[]>) => {
      setGroups(e.data);
    };
    workerRef.current = worker;
    return () => {
      worker.terminate();
      workerRef.current = null;
    };
  }, []);

  useEffect(() => {
    workerRef.current?.postMessage(events);
  }, [events]);

  return groups;
};
